<div class="modal fade modal-full-width modal-full-height">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <sgt-negocio-form-insert-wizard
                *ngIf="isInserting"
                class="form-wizard-container"
                #formWizard
                (afterCreateQualificacao)="onAfterCreateQualificacao($event)"
                (afterCreateOportunidade)="onAfterCreateOportunidade($event)"
                (afterClose)="close()">
            </sgt-negocio-form-insert-wizard>            
        </div>
    </div>
</div>